import * as React from 'react';
import { useContext, useEffect, useMemo } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { UserContext } from '../../store/userContext';

type Props = {
	storage: StorageType;
};

const UsersOfStorage: React.FC<Props> = ({ storage }) => {
	const theme = useTheme();
    const { users, getUsers, getUsersLoading } = useContext(UserContext);

    useEffect(() => {
        getUsers();
    }, [getUsers]);

    const storageUsers = useMemo(() => {
        if (!storage.siteId) {
            return [];
        }

        return users.filter((user) => user.siteIds?.includes(storage.siteId as number));
    }, [users, storage.siteId]);

	return (
		<Grid size={{ xs: 12 }}>
            <Box
                sx={{
                    backgroundColor: theme.palette.headerBackground,
                    p: 2,
                    height: 50,
                    borderBottom: theme.palette.border,
                }}>
                <Typography variant="subtitle2" sx={{ ...theme.typography.columnHeader }}>
                    Users of storage
                </Typography>
            </Box>
            {getUsersLoading && (
                <Typography sx={{ mt: 1, ...theme.typography.usersFontRegular }}>
                    Loading users...
                </Typography>
            )}

            {!getUsersLoading && storageUsers.length === 0 && (
                <Typography sx={{ mt: 1, ...theme.typography.usersFontRegular }}>
                    No users for {storage.name}.
                </Typography>
            )}

            {!getUsersLoading && storageUsers.map((user) => (
                <Box
                    key={user.id}
                    sx={{
                        display: 'flex',
                        height: '30px',
                        minHeight: '30px',
                        px: 1.5,
                        alignItems: 'center',
                        gap: '8px',
                        ...theme.typography.usersFontTitle,
                        mb: 0.5,
                        borderRadius: '4px',
                    }}
                >
                    <Box
                        component="span"
                        sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {user.email}
                    </Box>
                </Box>
            ))}
		</Grid>
	);
};

export default UsersOfStorage;
